import { useEffect, useState, Fragment } from 'react';
import useTotp from '../../Service/hooks/useTOTP';

export default function ScanQRCodeStep({ onNext, onPrevious, registrationState }) {

    const { getQRCode } = useTotp();


    const [qrcodeimage, setQRCodeImage] = useState('');

    useEffect(() => {
        (async () => {
            let {qrCodeImage} = await getQRCode();
            console.log("qrCodeImage", qrCodeImage);
            setQRCodeImage(qrCodeImage);
        })();
    }, []);


    return <div className="flex flex-col gap-3">
        { !qrcodeimage && <p>Bezig met laden...</p> }
        { qrcodeimage && <Fragment>
            <h1>Scan onderstaande code</h1>
            <div className="flex flex-row justify-center">
                <img src={qrcodeimage} />
            </div>
            <p>
                Scan nu met de camera van uw telefoon de bovenstaande qr code. En klik op volgende als u dit heeft gedaan.
            </p>
            <div className="flex flex-row gap-3 w-full">
                
                <button className="flex-1 px-3 py-2 bg-green-500 text-white" onClick={() => onNext()}>Volgende</button>
            </div>
        </Fragment> }
    </div>
}